import { Box, HStack, IconButton, Image, Text, VStack } from "@chakra-ui/react";
import { FaTrash } from "react-icons/fa";

const requiredImagePlaceholders = {
  square: {
    ratio: "1/1",
    title: "Square (*)",
    description: "instagram post, explore, facebook feed",
    minWidth: 1440,
    type: null,
    required: true,
    minHeight: 1440,
    url: undefined,
  },
  portrait: {
    ratio: "4/5",
    title: "Portrait (*)",
    description: "instagram story, facebook reels",
    required: true,
    type: null,
    minWidth: 1152,
    minHeight: 1440,
    url: undefined,
  },
};

const DisplayText = ({
  ratio,
  hasMedia = false,
}: {
  ratio: string;
  hasMedia?: boolean;
}) => {
  const toRender =
    requiredImagePlaceholders[ratio as keyof typeof requiredImagePlaceholders];

  if (!toRender) {
    return null;
  }

  return (
    <VStack
      w="full"
      pointerEvents={"none"}
      h="full"
      // position={"absolute"}
      opacity={hasMedia ? 0.5 : 1}
      background={hasMedia ? "rgba(255,255,255,0.8)" : undefined}
      alignItems={"center"}
      justifyContent={"space-around"}
      py={4}
      zIndex={10}
      pt={16}
    >
      <Text
        fontWeight={"bold"}
        textTransform={"uppercase"}
        textAlign={"center"}
      >
        {toRender.title}
      </Text>
      <Text fontSize={"sm"}>{toRender.ratio}</Text>
      {/* <Text textAlign={"center"} fontSize={"sm"}>
        {toRender.description}
      </Text> */}
      <Text fontSize={"sm"}>
        {toRender.minWidth}x{toRender.minHeight}
      </Text>
    </VStack>
  );
};

const MediaDisplay = ({
  media,
  ratio,
  mediaType = "single",
  isDisabled = false,
  type = "image",
  isLoading = false,
  onRemove = () => {},
  onClick = () => {},
}: {
  mediaType?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  onRemove?: (media: { url: string }) => void;
  onClick?: () => void;
  ratio: string;
  type?: "image" | "video";
  media: {
    url: string;
  }[];
}) => {
  return (
    <HStack gap={2} flexWrap={"nowrap"} flexShrink={0}>
      {media.map((media, index) => (
        <VStack key={media.url} position={"relative"} flexShrink={0}>
          <Box
            as={type === "image" ? "img" : "video"}
            rounded={"md"}
            cursor="pointer"
            onClick={() => {
              onClick();
            }}
            aspectRatio={ratio}
            height="200px"
            src={media.url}
            objectFit={"cover"}
            key={media.url}
            {...(type !== "image" && {
              autoPlay: true,
              muted: true,
              loop: true,
            })}
          />
          <IconButton
            pos={"absolute"}
            top={2}
            right={2}
            zIndex={20}
            isLoading={isLoading}
            isDisabled={isDisabled}
            aria-label="Remove video"
            icon={<FaTrash />}
            onClick={() => {
              onRemove(media);
            }}
          />
          <Box pos={"absolute"} bottom={2} right={2} zIndex={10}>
            <Text
              fontWeight={"bold"}
              fontSize={"xs"}
              rounded="full"
              bg="gray.100"
              w={mediaType === "carousel" ? 4 : undefined}
              px={mediaType === "carousel" ? 0 : 2}
              h={4}
              textAlign={"center"}
              lineHeight={4}
              textTransform={"uppercase"}
            >
              {mediaType === "carousel" ? index + 1 : ratio}
            </Text>
          </Box>
          {/* <Box pos={"absolute"} w="full" h="full" zIndex={10}>
            <DisplayText ratio={ratio} hasMedia={!!media.url} />
          </Box> */}
        </VStack>
      ))}
      <VStack>
        {mediaType === "carousel" || !media.length ? (
          <Box
            rounded={"md"}
            height="200px"
            cursor="pointer"
            onClick={() => {
              onClick();
            }}
            w="full"
            aspectRatio={
              requiredImagePlaceholders[
                ratio as keyof typeof requiredImagePlaceholders
              ].ratio
            }
            background={"gray.200"}
            objectFit={"cover"}
            pos={"relative"}
          >
            <Box pos={"absolute"} w="full" h="full" bg="rgba(255,255,255,0.5)">
              <DisplayText ratio={ratio} />
            </Box>
          </Box>
        ) : null}
      </VStack>
    </HStack>
  );
};

export default MediaDisplay;
